import comp from "./TagCard";

export default comp;
